export const examAdminDashboard = {
  pageTitle: "Platform Overview",
  pageSubtitle:
    "An admin portal centered on the three primary workflows: questions, papers, and exams.",
  superAdminSubtitle:
    "A system operations cockpit for super admins, focused on global progress, risks, and pending work.",
  stats: {
    questionsTotal: "Questions",
    papersTotal: "Papers",
    examsTotal: "Exams",
    runningExams: "Running Exams",
    upcomingExams: "Starting Within 24 Hours",
    endedPendingArchive: "Pending Archive",
    questionsHelper: "{count} draft questions",
    papersHelper: "{count} draft papers",
    examsHelper: "{count} draft exams",
    runningHelper: "Exams that are currently in progress",
    upcomingHelper: "Exams scheduled to start within the next 24 hours",
    endedHelper: "Ended exams that still need follow-up or archival",
  },
  focusTitle: "Core Priorities",
  focusTag: "Core",
  focusItems: {
    roleAware:
      "1. Current role: {role}. Pages and APIs in the admin portal are already scoped by role.",
    rbac: "2. Questions, papers, exams, review, and execution are split across role responsibilities. Button-level permissions can be refined as business policy requires.",
    priority:
      "3. The main create, view, and validate flows are the focus. Approval flows and fine-grained permissions follow business policy.",
  },
  recentExamsTitle: "Recent Exams",
  recentExamsItem: "Paper version {paperVersionLabel} · {createdAt}",
  recentExamsEmpty: {
    noExams: "No exams have been created yet",
    noPermission: "The current role cannot view the exam list",
  },
  heroTag: "Super Admin",
  heroTitle: "System Operations Cockpit",
  heroDescription:
    "A single workspace for the question, paper, and exam workflows, designed to surface risks, backlog, and urgent actions first.",
  heroSideTitle: "Priority Alerts",
  headerActions: {
    createQuestion: "Create Question",
    createExam: "Create Exam",
  },
  tasksTitle: "Pending Work",
  tasksTag: "Action Queue",
  tasks: {
    draftQuestions: "Draft Questions",
    draftQuestionsHelper: "Complete content and publish status for draft questions first",
    draftPapers: "Draft Papers",
    draftPapersHelper: "Check assembly progress so papers do not stay in draft too long",
    draftExams: "Draft Exams",
    draftExamsHelper: "Finalize configuration and publish soon to avoid scheduling delays",
    runningExams: "Running Exams",
    runningExamsHelper: "Watch running status, proctoring, and abnormal feedback",
    endedExams: "Ended, Pending Archive",
    endedExamsHelper: "Archive ended exams promptly to keep exam status clean",
    upcomingExams: "Upcoming Exams",
    upcomingExamsHelper: "Check schedule windows, paper versions, and proctoring in advance",
  },
  activityTitle: "Recent Activity",
  activityTag: "Timeline",
  activityActor: "Operator: {name}",
  activityKinds: {
    question: "Question",
    paper: "Paper",
    exam: "Exam",
  },
  risksTitle: "Risks & Reminders",
  risksTag: "Attention",
  risks: {
    examStartingSoonTitle: "An exam is starting within 1 hour",
    examStartingSoonDescription: '"{name}" starts at {time}. Final checks should be completed now.',
    examEndingSoonTitle: "A running exam will end within 2 hours",
    examEndingSoonDescription:
      '"{name}" ends at {time}. Watch for submission and review follow-up.',
    oldDraftQuestionTitle: "There is a long-standing draft question",
    oldDraftQuestionDescription:
      '"{name}" was created at {time}. Review whether to continue or clean it up.',
    oldDraftPaperTitle: "There is a long-standing draft paper",
    oldDraftPaperDescription: '"{name}" was created at {time}. Finish assembly or archive it soon.',
    stableTitle: "No high-priority risks detected",
    stableDescription: "The core workflows for questions, papers, and exams look stable overall.",
  },
  quickActionsTitle: "Quick Access",
  quickActionsTag: "Quick Access",
  quickActions: {
    createQuestionTitle: "Create Question",
    createQuestionDescription: "Jump into the question creation drawer and expand the bank.",
    createPaperTitle: "Create Paper",
    createPaperDescription: "Start assembling a paper and complete its structure.",
    createExamTitle: "Create Exam",
    createExamDescription: "Configure schedule, paper version, and rules to launch an exam.",
    goQuestionsTitle: "Open Question Center",
    goQuestionsDescription: "Review list, draft, and archived question states.",
    goPapersTitle: "Open Paper Center",
    goPapersDescription: "Manage paper versions, archive state, and assembly progress.",
    goExamsTitle: "Open Exam Center",
    goExamsDescription: "Review exam status, archival state, and operating metrics.",
    goSystemSettingsTitle: "Open System Settings",
    goSystemSettingsDescription:
      "Check site configuration, security policies, and AI integration settings.",
    goAuditLogsTitle: "Open Audit Logs",
    goAuditLogsDescription: "Trace key operations and login activities.",
  },
  viewNow: "View Now",
};
